/**************************************************
 * Nombre:       Formulario_Productos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import IngresoTexto from "../../../Modulo_formularios/Componentes/IngresoTexto";
import {BedroomParentOutlined} from "@mui/icons-material";
import IngresoDinero from "../../../Modulo_formularios/Componentes/IngresoDinero";
import {useIngresarObjeto} from "../../../Modulo_formularios/Hooks/useIngresarObjeto";
import {Tarjeta_Adicional} from "../../Tarjetas/Tarjeta_Adicional";
import Formulario_Reserva_Adicional from "./Formulario_Reserva_Adicional";
import {formatoMoneda} from "../../../Utilidades/formatoMoneda";
import {useEffect, useState} from "react";
import {obtenerValorSaldo} from "../../../CodNegocio/obtenerValorSaldo";

const Formulario_Reserva_Adicionales = ({...props}) => {
    const {IngresarObjeto} = useIngresarObjeto({
        props: props,
        dato: 'adicionales',
        nombre: 'Items Adicionales',
        Formulario: Formulario_Reserva_Adicional,
        Tarjeta: Tarjeta_Adicional,
    })
    const [valorSaldo, setValorSaldo] = useState(false)


    useEffect(() => {

        if (props.props) {
            let valores = props.props.getValues()
            setValorSaldo(obtenerValorSaldo({
                totalReserva: valores.valor,
                adicionales: valores.adicionales,
                descuentos: valores.descuentos,
                abonos: valores.abonos,
            }))
        }

    }, [props.props])
    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >

                <Grid container size={{xs: 6, sm: 6, md: 6}}>
                    <IngresoDinero Icono={BedroomParentOutlined} nombre={'# Habitacion'} dato={'numero'}
                                   editable={false} {...props} />
                </Grid>

                <Grid container size={{xs: 6, sm: 6, md: 6}} justifyContent={'flex-end'}>
                    <Typography sx={{fontSize: 18, fontWeight: 800}}>
                        {`Saldo: ${formatoMoneda(valorSaldo)}`}
                    </Typography>
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresarObjeto/>
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Typography sx={{fontSize: 14}}>Notas Internas</Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto nombre={'Notas Internas'} dato={'notas'} {...props}
                                  lineas={6}

                    />
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Reserva_Adicionales